import _inheritsLoose from "@babel/runtime-corejs3/helpers/inheritsLoose";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js/instance/concat";
import { __decorate } from "tslib";
import { Component } from 'intact-vue-next';
import { bind } from '../utils';
import template from './item.vdt';
import { useRouter, navigate } from '../../hooks/useRouter';
import { useConfigContext } from '../config';
var typeDefs = {
  to: [String, Object]
};
export var BreadcrumbItem = /*#__PURE__*/function (_Component) {
  _inheritsLoose(BreadcrumbItem, _Component);
  function BreadcrumbItem() {
    var _context;
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, _concatInstanceProperty(_context = [this]).call(_context, args)) || this;
    _this.router = useRouter();
    _this.config = useConfigContext();
    return _this;
  }
  var _proto = BreadcrumbItem.prototype;
  _proto.onClick = function onClick() {
    navigate(this.router.value, this.get('to'));
  };
  return BreadcrumbItem;
}(Component);
BreadcrumbItem.template = template;
BreadcrumbItem.typeDefs = typeDefs;
__decorate([bind], BreadcrumbItem.prototype, "onClick", null);